import { render, staticRenderFns } from "./UploadLater.vue?vue&type=template&id=21e48313&scoped=true"
import script from "./UploadLater.vue?vue&type=script&lang=ts"
export * from "./UploadLater.vue?vue&type=script&lang=ts"
import style0 from "./UploadLater.vue?vue&type=style&index=0&id=21e48313&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21e48313",
  null
  
)

export default component.exports